import React from 'react';
import { Modal } from 'antd';

type ForceHTTPSConfirmModalProps = {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
};

function ForceHTTPSConfirmModal({ open, onOk, onCancel }: ForceHTTPSConfirmModalProps) {
  return (
    <Modal title="Enforce HTTPS Protocol" open={open} onOk={onOk} onCancel={onCancel}>
      <p>
        All URLs using the <b>http</b> protocol will be <b>removed</b> and replaced with the same URLs using the{' '}
        <b>https</b> protocol
      </p>
    </Modal>
  );
}

export default ForceHTTPSConfirmModal;
